import 'slick-carousel/slick/slick'

export default class GallerySlider {

    constructor() {

        this.settings = {
            $slider : $('.js-gallery-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 5,
                slidesToScroll: 1,
                dots: true,
                appendDots: $('.js-gallery-slider-dots'),
                prevArrow: $('.js-gallery-slider-previous'),
                nextArrow: $('.js-gallery-slider-next'),

                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 640,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 500,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    },
                ]
            });
        }

    }

};

new GallerySlider();